<template>
    <div class="question-view-wrapper" @mouseover="mouseOnView" @mouseout="mouseOutView" :style="{ top: positionTop, left: positionLeft }">
        <div class="view-title">{{ title }}</div>
        <div class="view-content">{{ content }}</div>
    </div>
</template>

<script>
export default {
    name: "QuestionSimpleView",
    props: ["content", "positionTop", "positionLeft"],
    computed: {
        title() {
            return this.$t("zhiji.answer.answerDetail");
        }
    },
    methods: {
        mouseOnView() {
            this.$emit("onview");
        },
        mouseOutView() {
            this.$emit("outview");
        }
    }
};
</script>

<style lang="scss" scoped>
.question-view-wrapper {
    margin-bottom: 16px;
    width: 277px;
    background: #fff;
    position: absolute;
    z-index: 1;
    top: 64px;
    left: 5px;
    border-radius: 4px;
    box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);

    .view-title {
        background: #e3edf6;
        padding: 8px;
    }

    .view-content {
        box-sizing: border-box;
        padding: 8px;
        width: 100%;
        overflow: hidden;
        word-break: normal;
    }
}
</style>
